module.exports = __webpack_public_path__ + "static/media/2.Motor Based Vibrator.db118a4b.jpg";